import React from 'react';
import { compose } from 'recompose';
import { AdminUsers } from '../../components/scenes/Admin/Users';
import Layout from '../../utils/layout';
import {
  withAuthorization,
  withEmailVerification,
} from '../../utils/Session';

const condition = (authUser) => !!authUser;
const AdminPage = compose(
  withEmailVerification,
  withAuthorization(condition),
)(AdminUsers);

export default () => (
  <Layout>
    <AdminPage />
  </Layout>
);
